import React, { useState, useEffect } from "react"; 
import { fetchCartList, modifyCartItem, baseURL } from '../../utils/cart';
import { createOrder } from '../../utils/order';
import { useLocation } from 'react-router-dom';

import  ZendeskWidget  from "../../Components/CustomerSupport/ZendeskWidget";

//Import Breadcrumb
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { Link } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Row,
  CardHeader,
  UncontrolledAlert,
} from "reactstrap";
import { ToastContainer, toast } from 'react-toastify';
 
const CartList= () => {
  const location = useLocation();
  const [cartData, setCartData] = useState(null);
  
  const [loading, setLoading] = useState(true);
  const [grandTotal, setGrandTotal] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [dis, setDiscount] = useState(0);
  const [charge, setShippingCharge] = useState(0);
  const [tax, setTax] = useState(0);
  // const [loading, setLoading] = useState(true);
  const errornotify = (error) => toast(error, { position: "top-center", hideProgressBar: true, closeOnClick: false, className: 'bg-danger text-white' });
  const successnotify = (message) => toast(message, { position: "top-center", hideProgressBar: true, closeOnClick: false, className: 'bg-success text-white' });
 
  const calculateDiscount = (total) => {
    return 
  };
  
  const calculateShipping = (total) => {
    // Your shipping charge logic here
  };

  useEffect(() => {
    const loadCartListData = async () => {
      try {
        const data = await fetchCartList(); 
        
        // Handle error responses
        if (data && data.status && data.status !== 200) {
          console.error('Cart API error:', data);
          errornotify(data.data?.message || "Failed to load cart");
          setCartData(null);
          return;
        }
        
        // Handle successful response
        if (data && data.data) {
          setCartData(data.data);
        } else {
          console.error('Invalid cart data structure:', data);
          errornotify("Invalid cart data received");
          setCartData(null);
        }
      } catch (error) {
        console.error("Error loading profile:", error);
      } finally {
        setLoading(false);
      }
    };

    loadCartListData();
  }, []);
  
  
  const handleCartUpdate = async (values) => {
    try {   
      // Make API call with error handling
      const modify_response = await modifyCartItem(values); 
      if (modify_response.status==200) {  
          // Fetch updated cart data after modifying an item
          const id = modify_response.data.cart_item.id
          cartData.cart_items.map((item,index) => {
            if (values.remove&&item.id === id){

              var filteredCart = cartData.cart_items.filter(cartitem => cartitem.id!==  id);
              cartData.cart_items = filteredCart; 
              console.log(cartData);
            }else if(!values.remove&&item.id === id){
              item.quantity = modify_response.data.cart_item.quantity 
            }else{ 
              return item;
            }
            
        });  
        setCartData(cartData); 
        updateOrderSummary(cartData);
           
      }
      else{
        errornotify(modify_response.message)
      }
  
    } catch (err) {
      console.error('Submission failed:', err);

    }
  };

  const updateOrderSummary = (cartData) => {
    if (!cartData || !cartData.cart_items) return;

    const newSubTotal = cartData.cart_items.reduce(
        (acc, item) => acc + item.edition.price * item.quantity, 0
    );
    
    setSubTotal(newSubTotal);
    setDiscount((cartData.discount ?? 0.15 * newSubTotal));
    setShippingCharge(newSubTotal > 0 ? 65 : 0);
    setTax((newSubTotal * 0.125));  // Assuming 12.5% tax rate
    setGrandTotal((newSubTotal +(newSubTotal > 0 ? 65 : 0) +(newSubTotal * 0.125)) );
};

useEffect(() => {
  if (cartData) {
      updateOrderSummary(cartData);
  }
}, [cartData]);  // Update totals whenever cartData changes


  if (loading) {
    return (
      <div className="page-content">
        <Container fluid>
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-3">Loading your cart...</p>
          </div>
        </Container>
      </div>
    );
  }

  if (!cartData) {
    return (
      <div className="page-content">
        <Container fluid>
          <div className="text-center py-5">
            <div className="avatar-md mx-auto my-3">
              <div className="avatar-title bg-danger-subtle text-danger fs-36 rounded-circle">
                <i className='bx bx-error-circle'></i>
              </div>
            </div>
            <h5 className="mb-3">Failed to Load Cart</h5>
            <p className="text-muted mb-4">There was an error loading your cart data.</p>
            <button 
              className="btn btn-primary w-md mb-3" 
              onClick={() => window.location.reload()}
            >
              Try Again
            </button>
          </div>
        </Container>
      </div>
    );
  }

  function removeCartItem(id, quantity) { 
    handleCartUpdate({'id': id, 'add': 0, 'reduce': quantity,remove: true});
  }

  function countUP(id, quantity, itemPrice) { 
    handleCartUpdate({'id': id, 'add': 1, 'reduce': 0});
  }

  function countDown(id, prev_data_attr, itemPrice) {
    handleCartUpdate({'id': id, 'add': 0, 'reduce': 1});
  }

  
  // const [cartList, setCartList] = useState(null);
  // useEffect(() => {
  //   dispatch(onGetCartList())
  // }, [dispatch])
  
  // useEffect(() => {
  //   dispatch(onGetTodos());
  // }, [dispatch]);

  document.title="Shopping Cart | SeedNations";
  return (
    <React.Fragment>
      <div className="page-content">
        <ZendeskWidget />
        <Container fluid>
        <ToastContainer />
          <BreadCrumb title="Shopping Cart" pageTitle="Ecommerce" />

          {/* Show message if redirected from checkout */}
          {location.state?.message && (
            <Row className="mb-3">
              <Col>
                <UncontrolledAlert color="warning" className="border-dashed">
                  <div className="d-flex align-items-center">
                    <i className="bx bx-info-circle fs-18 text-warning me-2"></i>
                    <div>
                      <h6 className="mb-1">Access Restricted</h6>
                      <p className="mb-0">{location.state.message}</p>
                    </div>
                  </div>
                </UncontrolledAlert>
              </Col>
            </Row>
          )}

          <Row className="mb-3">
            <Col xl={8} lg={8} md={12} sm={12}>
              <Row className="align-items-center gy-3 mb-3">
                <div className="col-sm">
                  <div>
                    <h5 className="fs-14 mb-0">Your Cart ({cartData?cartData.cart_items?cartData.cart_items.length:0:0} items)</h5>
                  </div>
                </div>
                <div className="col-sm-auto">
                  <Link
                    to="/product-list"
                    className="link-primary text-decoration-underline"
                  >
                    Continue Shopping
                  </Link>
                </div>
              </Row>
              {cartData && cartData.cart_items && cartData.cart_items.length > 0 ? cartData.cart_items.map((cartItem, key) => (
                <React.Fragment key={cartItem.id}>
                  <Card className="product">
                    <CardBody>
                      <Row className="gy-3">
                        <div className="col-sm-auto">
                          <div className="avatar-lg bg-light rounded p-1">
                            <img
                              src={
                                cartItem.edition && 
                                cartItem.edition.images && 
                                cartItem.edition.images.length > 0
                                    ? baseURL + "/file/product/image/" + cartItem.edition.images[0].image_url
                                    : baseURL + "/file/product/image/aa6a16aa87d64a76ad37b77060a2a224.webp"
                              }
                              alt={
                                cartItem.edition && 
                                cartItem.edition.images && 
                                cartItem.edition.images.length > 0
                                    ? cartItem.edition.images[0].alt_text || "Product Image"
                                    : "No Image"
                              }
                              className="img-fluid d-block"
                              onError={(e) => {
                                  e.target.src = baseURL + "/file/product/image/aa6a16aa87d64a76ad37b77060a2a224.webp";
                                  e.target.onerror = null; // Prevent infinite loop
                              }}
                            />
                          </div>
                        </div>
                        <div className="col-sm">
                                                      <h5 className="fs-14 text-truncate">
                              <Link
                                to="/ecommerce-product-detail"
                                className=""
                              >
                                {cartItem.product?.name || "Product"}-{cartItem.edition?.edition_name || "Edition"}
                              </Link>
                            </h5>
                          <ul className="list-inline text-muted">
                            <li className="list-inline-item">
                              Color :{" "}
                              <span className="fw-medium">
                                {cartItem.edition?.color || "Not specified"}
                              </span>
                            </li>
                            <li className="list-inline-item">
                              Size :{" "}
                              <span className="fw-medium">{cartItem.edition?.boxsize || "Not mentioned"}</span>
                            </li>
                          </ul>

                          <div className="input-step">
                            <buttonxx
                              type="button"
                              className="minus"
                              onClick={() => {
                                countDown(cartItem.id, cartItem.quantity, cartItem.edition.price);
                              }}
                            >
                              –
                            </buttonxx>
                            <Input
                              type="text"
                              className="product-quantity"
                              value={cartItem.quantity}
                              name="demo_vertical"
                              readOnly
                            />
                            <button
                              type="button"
                              className="plus"
                              onClick={() => {
                                countUP(cartItem.id, cartItem.quantity, cartItem.edition.price);
                              }}
                            >
                              +
                            </button>
                          </div>
                        </div>
                        <div className="col-sm-auto">
                          <div className="text-lg-end">
                            <p className="text-muted mb-1">Item Price:</p>
                            <h5 className="fs-14">
                              $
                              <span id="ticket_price" className="product-price">
                                {cartItem.edition?.price || "0.00"}
                              </span>
                            </h5>
                          </div>
                        </div>
                      </Row>
                    </CardBody>

                    <div className="card-footer">
                      <div className="row align-items-center gy-3">
                        <div className="col-sm">
                          <div className="d-flex flex-wrap my-n1">
                            <div>
                              <Link
                                to="#"
                                className="d-block p-1 px-2"
                                onClick={() => removeCartItem(cartItem.id, cartItem.quantity)}
                              >
                                <i className="ri-delete-bin-fill text-muted align-bottom me-1"></i>{" "}
                                Remove
                              </Link>
                            </div>
                            <div>
                              <Link
                                to="#"
                                className="d-block p-1 px-2"
                              >
                                <i className="ri-star-fill text-muted align-bottom me-1"></i>{" "}
                                Add Wishlist
                              </Link>
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-auto">
                          <div className="d-flex align-items-center gap-2 text-muted">
                            <div>Total :</div>
                            <h5 className="fs-14 mb-0">
                              $
                              <span className="product-line-price">
                                {" "}
                                {(cartItem.total)}
                              </span>
                            </h5>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Card>
                </React.Fragment>
              )) : (
                <Col lg={12}>
                  <div className="text-center py-5">
                    <div className="avatar-md mx-auto my-3">
                      <div className="avatar-title bg-info-subtle text-info fs-36 rounded-circle">
                        <i className='bx bx-cart'></i>
                      </div>
                    </div>
                    <h5 className="mb-3">Your Cart is Empty!</h5>
                    <p className="text-muted mb-4">Add some products to your cart to get started.</p>
                    <Link to="/product-list" className="btn btn-success w-md mb-3">Shop Now</Link>
                  </div>
                </Col>
              )}

              <div className="text-end mb-4">

                
                {cartData && cartData.cart_items && cartData.cart_items.length > 0 ? (
                  <Link
                    to="/check-out"
                    className="btn btn-primary btn-label right ms-auto"
                  >
                    <i className="ri-arrow-right-line label-icon align-bottom fs-16 ms-2"></i>{" "}
                    Checkout
                  </Link>
                ) : (
                  <button 
                    className="btn btn-secondary btn-label right ms-auto" 
                    disabled
                    title="Add items to cart to checkout"
                  >
                    <i className="ri-arrow-right-line label-icon align-bottom fs-16 ms-2"></i>{" "}
                    Checkout
                  </button>
                )}
              </div>
            </Col>

            <Col xl={4} lg={4} md={12} sm={12}>
              <div className="sticky-side-div">
                <Card>
                  <CardHeader className="border-bottom-dashed">
                    <h5 className="card-title mb-0">Order Summary</h5>
                  </CardHeader>
                  <CardHeader className="bg-light-subtle border-bottom-dashed">
                    <div className="text-center">
                      <h6 className="mb-2">
                        Have a <span className="fw-semibold">promo</span> code ?
                      </h6>
                    </div>
                    <div className="hstack gap-3 px-3 mx-n3">
                      <input
                        className="form-control me-auto"
                        type="text"
                        placeholder="Enter coupon code"
                        aria-label="Add Promo Code here..."
                      />
                      <button type="button" className="btn btn-primary w-xs">
                        Apply
                      </button>
                    </div>
                  </CardHeader>
                  <CardBody className="pt-2">
                    <div className="table-responsive">
                      <table className="table table-borderless mb-0">
                        <tbody>
                          <tr>
                            <td>Sub Total :</td>
                            <td className="text-end" id="cart-subtotal">
                              $ {subTotal}
                            </td>
                          </tr>
                          <tr>
                            <td>
                              Discount{" "}
                              <span className="text-muted"></span> :{" "}
                            </td>
                            <td className="text-end" id="cart-discount">
                              - $ {dis}
                            </td>
                          </tr>
                          <tr>
                            <td>Shipping Charge :</td>
                            <td className="text-end" id="cart-shipping">
                              $ {charge}
                            </td>
                          </tr>
                          <tr>
                            <td>Estimated Tax (12.5%) : </td>
                            <td className="text-end" id="cart-tax">
                              $ {tax}
                            </td>
                          </tr>
                          <tr className="table-active">
                            <th>Total (USD) :</th>
                            <td className="text-end">
                              <span className="fw-semibold" id="cart-total">
                                ${grandTotal }
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </CardBody>
                </Card>

                <UncontrolledAlert color="primary" className="border-dashed">
                  <div className="d-flex align-items-center">
                    <lord-icon
                      src="https://cdn.lordicon.com/nkmsrxys.json"
                      trigger="loop"
                      colors="primary:#121331,secondary:#25a0e2"
                      style={{ width: "80px", height: "80px" }}
                    ></lord-icon>
                    <div className="ms-2">
                      <h5 className="fs-14 text-primary fw-semibold">
                        {" "}
                        Buying for a loved one?
                      </h5>
                      <p className="text-black mb-1">
                        Gift wrap and personalised message on card, <br />
                        Only for <span className="fw-semibold">$9.99</span> USD
                      </p>
                      <button
                        type="button"
                        className="btn ps-0 btn-sm btn-link text-primary text-uppercase"
                      >
                        Add Gift Wrap
                      </button>
                    </div>
                  </div>
                </UncontrolledAlert>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CartList;
